import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, CampoComune } from '../components/';


interface IInputComuneProps extends Dati.IBaseProps {
    Etichetta: any;
    Valore: string;
    CAP?: string;
    Provincia?: string;
}

export class InputComune extends BasePureComponent<IInputComuneProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string") && this.props.Etichetta != "") {
            etichetta = <label>{this.props.Etichetta}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }
        return <div style={{ minHeight: 88 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <CampoComune Id={this.props.Id} Name={this.props.Name} Valore={this.props.Valore} OnChange={this.props.OnChange} OnBlur={this.props.OnBlur} CAP={this.props.CAP} Provincia={this.props.Provincia} />
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputComune.tsx